import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 131,
	height: 108,
	viewBox: "0 0 131 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.55371 49.448V50.5575",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.06055 50.0493L2.96717 50.9826",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 52.5337H2.28195",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.95605 55.0624L2.86267 54.1292",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.55371 55.3656V54.2561",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.40275 54.6259L5.66309 53.8862",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.88196 52.7769H6.77246",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14299 50.1877L6.40332 50.9274",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.0967 1V1.73967",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.8779 3.21899H62.6176",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.0967 5.43815V4.69849",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.9457 3.21899H65.2061",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1963 32.0659V33.1754",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8682 35.3948H18.9777",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1963 38.3532V37.2437",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1554 35.3948H23.0459",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.801 72.3921C101.685 72.3921 102.401 73.1091 102.401 73.9931C102.401 74.8775 101.685 75.5942 100.801 75.5942C99.917 75.5942 99.2002 74.8775 99.2002 73.9931",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M108.125 57.8666C109.075 57.5701 110.532 56.4078 110.869 55.1572C111.175 56.2627 112.457 57.5701 113.614 57.669C112.312 58.1301 111.067 59.4997 110.869 60.5756C110.735 59.4789 109.013 58.0264 108.125 57.8666Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.5674 71.899C11.0427 71.7507 11.7708 71.1697 11.9394 70.5444C12.0923 71.0969 12.7332 71.7507 13.3115 71.8003C12.6606 72.0305 12.0383 72.7155 11.9394 73.2535C11.8723 72.7051 11.0113 71.9787 10.5674 71.899Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.3885 20.4519C19.3885 21.1378 18.8328 21.6934 18.1474 21.6934C17.4617 21.6934 16.9062 21.1378 16.9062 20.4519C16.9062 19.7663 17.4617 19.2104 18.1474 19.2104C18.8328 19.2104 19.3885 19.7663 19.3885 20.4519Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M102.265 23.7857C102.265 24.9316 101.336 25.8606 100.191 25.8606C99.0449 25.8606 98.1162 24.9316 98.1162 23.7857C98.1162 22.6397 99.0449 21.7107 100.191 21.7107C101.336 21.7107 102.265 22.6397 102.265 23.7857Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M131 18.1638C131 19.073 130.263 19.8097 129.355 19.8097C128.446 19.8097 127.709 19.073 127.709 18.1638C127.709 17.2546 128.446 16.5178 129.355 16.5178C130.263 16.5178 131 17.2546 131 18.1638Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42.5842 95.0364C42.5842 95.6096 42.1198 96.0741 41.5468 96.0741C40.9741 96.0741 40.5098 95.6096 40.5098 95.0364C40.5098 94.4633 40.9741 93.9988 41.5468 93.9988C42.1198 93.9988 42.5842 94.4633 42.5842 95.0364Z",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.9657 12.4763C41.9657 13.1622 41.4099 13.7178 40.7245 13.7178C40.0391 13.7178 39.4834 13.1622 39.4834 12.4763C39.4834 11.7907 40.0391 11.2349 40.7245 11.2349C41.4099 11.2349 41.9657 11.7907 41.9657 12.4763Z",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73.6272 106.527C72.8341 106.828 71.9465 106.43 71.6448 105.637C71.3431 104.844 71.7412 103.955 72.5346 103.654C73.3274 103.352 74.215 103.75 74.5167 104.544C74.8187 105.337 74.4203 106.225 73.6272 106.527Z",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73.1572 77.1849H42.8292C40.6946 77.1849 38.9473 75.4324 38.9473 73.2906V30.0414C38.9473 27.8995 40.6946 26.1479 42.8292 26.1479H73.1572C75.2927 26.1479 77.04 27.8995 77.04 30.0414V73.2906C77.04 75.4324 75.2927 77.1849 73.1572 77.1849Z",
			fill: "#7ABCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M70.5684 79.034H40.2403C38.1057 79.034 36.3584 77.2815 36.3584 75.1397V31.8905C36.3584 29.7487 38.1057 27.9971 40.2403 27.9971H70.5684C72.7039 27.9971 74.4512 29.7487 74.4512 31.8905V75.1397C74.4512 77.2815 72.7039 79.034 70.5684 79.034Z",
			fill: "#A5D0F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M68.0502 80.4941H37.6595C35.5205 80.4941 33.7695 78.7488 33.7695 76.6159V33.5457C33.7695 31.4128 35.5205 29.6685 37.6595 29.6685H68.0502C70.1901 29.6685 71.9411 31.4128 71.9411 33.5457V76.6159C71.9411 78.7488 70.1901 80.4941 68.0502 80.4941Z",
			fill: "#9ACCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M68.0502 80.4941H37.6595C35.5205 80.4941 33.7695 78.7488 33.7695 76.6159V33.5457C33.7695 31.4128 35.5205 29.6685 37.6595 29.6685H68.0502C70.1901 29.6685 71.9411 31.4128 71.9411 33.5457V76.6159C71.9411 78.7488 70.1901 80.4941 68.0502 80.4941Z",
			fill: "#DAEDFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6697 42.7905H41.2224C40.5814 42.7905 40.0566 42.2913 40.0566 41.6814C40.0566 41.0707 40.5814 40.5715 41.2224 40.5715H63.6697C64.3107 40.5715 64.8354 41.0707 64.8354 41.6814C64.8354 42.2913 64.3107 42.7905 63.6697 42.7905Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6697 49.4475H41.2224C40.5814 49.4475 40.0566 48.9483 40.0566 48.3384C40.0566 47.7277 40.5814 47.2285 41.2224 47.2285H63.6697C64.3107 47.2285 64.8354 47.7277 64.8354 48.3384C64.8354 48.9483 64.3107 49.4475 63.6697 49.4475Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6697 56.1045H41.2224C40.5814 56.1045 40.0566 55.6053 40.0566 54.9954C40.0566 54.3855 40.5814 53.8855 41.2224 53.8855H63.6697C64.3107 53.8855 64.8354 54.3855 64.8354 54.9954C64.8354 55.6053 64.3107 56.1045 63.6697 56.1045Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6697 62.7617H41.2224C40.5814 62.7617 40.0566 62.2625 40.0566 61.6526C40.0566 61.0419 40.5814 60.5427 41.2224 60.5427H63.6697C64.3107 60.5427 64.8354 61.0419 64.8354 61.6526C64.8354 62.2625 64.3107 62.7617 63.6697 62.7617Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.9395 69.4185H41.2274C40.5836 69.4185 40.0566 68.9192 40.0566 68.3094C40.0566 67.6987 40.5836 67.1995 41.2274 67.1995H52.9395C53.5833 67.1995 54.1103 67.6987 54.1103 68.3094C54.1103 68.9192 53.5833 69.4185 52.9395 69.4185Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M76.5769 60.815C72.0883 65.3028 65.1395 65.8091 60.0947 62.3442C59.45 61.8935 58.8363 61.3872 58.2641 60.815C57.9695 60.5214 57.6918 60.2184 57.4302 59.8994C56.9069 59.2623 56.4485 58.5829 56.073 57.8809C55.4113 56.6952 54.9614 55.437 54.7158 54.1365C53.9233 50.0581 55.1083 45.6682 58.2641 42.5138C61.4274 39.3501 65.8181 38.1728 69.8972 38.9577C71.197 39.2108 72.4563 39.6606 73.6422 40.3146C74.3453 40.6986 75.0154 41.1569 75.6536 41.6801C75.9717 41.9407 76.2748 42.2193 76.5684 42.5138C77.1416 43.086 77.6555 43.6986 78.0979 44.3441C81.5643 49.3871 81.057 56.3357 76.5769 60.815Z",
			fill: "white",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M75.3181 59.931C70.6484 64.6016 63.0807 64.6008 58.4101 59.931C53.7456 55.2665 53.7456 47.698 58.4162 43.0283C63.0807 38.3637 70.6484 38.3637 75.3129 43.0283C79.9826 47.698 79.9826 55.2665 75.3181 59.931ZM77.7161 40.6291C71.7221 34.635 62.009 34.635 56.015 40.6291C50.0219 46.6222 50.0167 56.3414 56.0098 62.3354C61.4651 67.7889 70.0155 68.2807 76.0295 63.803C76.6169 63.3651 77.1826 62.8741 77.7222 62.3354C78.261 61.7958 78.7519 61.2301 79.189 60.6427C83.6667 54.6278 83.1705 46.0834 77.7161 40.6291Z",
			fill: "#69B0F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M101.306 84.9299L101.055 85.1816C99.3899 86.8473 96.6637 86.8473 94.998 85.1816L79.626 69.8096L85.9343 63.5012L101.306 78.8732C102.972 80.5389 102.972 83.2643 101.306 84.9299Z",
			fill: "url(#paint0_linear_2102_4216)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M79.5218 60.1726L84.0643 64.7151L80.8395 67.9391L76.2979 63.3966C76.8973 62.9497 77.4736 62.4487 78.0251 61.899C78.5749 61.3492 79.0758 60.772 79.5218 60.1726Z",
			fill: "#69B0F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M101.076 78.684L94.8081 84.9513L93.6797 83.822L99.947 77.5547L101.076 78.684Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.2834 63.7184L79.8435 70.1584L78.8867 69.2017L85.3266 62.7617L86.2834 63.7184Z",
			fill: "url(#paint1_linear_2102_4216)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M72.2301 41.4218L56.4369 57.2142C55.8422 56.1482 55.4377 55.0171 55.2178 53.848L68.8637 40.2019C70.0321 40.4303 71.1641 40.8339 72.2301 41.4218Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M77.4078 45.1754L60.3337 61.2822C59.7222 60.8796 59.1402 60.4266 58.5975 59.9146C58.3181 59.651 58.0539 59.3807 57.8066 59.0952L75.0887 42.7905C75.3913 43.0246 75.6788 43.2739 75.9573 43.5375C76.5 44.0495 76.9882 44.5977 77.4078 45.1754Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8722 51.4998L72.7129 47.659C72.8952 47.4771 72.9977 47.2301 72.9979 46.9726C72.9982 46.715 72.8961 46.4679 72.7141 46.2857C72.5321 46.1034 72.2852 46.0008 72.0277 46.0006C71.7701 46.0004 71.523 46.1025 71.3407 46.2844L67.5 50.1252L63.6593 46.2844C63.477 46.1022 63.2298 45.9998 62.972 45.9998C62.7142 45.9998 62.467 46.1022 62.2847 46.2844C62.1024 46.4667 62 46.7139 62 46.9717C62 47.2295 62.1024 47.4767 62.2847 47.659L66.1254 51.4998L62.2847 55.3405C62.1024 55.5228 62 55.77 62 56.0278C62 56.2856 62.1024 56.5328 62.2847 56.7151C62.467 56.8974 62.7142 56.9998 62.972 56.9998C63.2298 56.9998 63.477 56.8974 63.6593 56.7151L67.5 52.8743L71.3407 56.7151C71.523 56.8974 71.7702 56.9998 72.028 56.9998C72.2858 56.9998 72.533 56.8974 72.7153 56.7151C72.8976 56.5328 73 56.2856 73 56.0278C73 55.77 72.8976 55.5228 72.7153 55.3405L68.8722 51.4998Z",
			fill: "#56A3F1"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2102_4216",
			x1: 91.0908,
			y1: 52.0364,
			x2: 68.1612,
			y2: 74.966,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B2DAFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#3699FF"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2102_4216",
			x1: 82.585,
			y1: 59.0634,
			x2: 75.1884,
			y2: 66.46,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1770CC" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6FB6FF"
			})]
		})] })
	]
});
export default SvgEmptyState;
